import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { LoggerService } from './app/_utils/logger.service';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Extend Window interface
declare global {
  interface Window {
    consoleOld?: Console;
    restoreConsole?: (secret?: string) => void;
  }
}

if (environment.production) {
  enableProdMode();

  // Deep copy the console object to preserve method bindings
  window.consoleOld = Object.create(
    Object.getPrototypeOf(console),
    Object.getOwnPropertyDescriptors(console)
  );

  // Override console methods
  const noOp = () => {};
  console.log = noOp;
  console.error = noOp;
  console.warn = noOp;
  console.info = noOp;
  console.debug = noOp;
  console.table = noOp;
}

// Bootstrap the app and get the injector
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((moduleRef) => {
    const logger = moduleRef.injector.get(LoggerService);

    // Define restoreConsole to handle both global console and LoggerService
    window.restoreConsole = (secret?: string) => {
      if (secret === '123') {
        // Restore global console if backed up
        if (window.consoleOld) {
          Object.assign(console, window.consoleOld);
          console.log('Global console restored!');
        }
        // Enable LoggerService logging
        logger.enableLogging();
        console.log('Application logging enabled via LoggerService');
      } else {
        console.log('Invalid secret');
      }
    };
  })
  .catch((err) => {
    // Use window.consoleOld to log errors in production
    if (window.consoleOld) {
      window.consoleOld.error('Bootstrap error:', err);
    } else {
      // Fallback if consoleOld is not available
      (console.error as any)(err);
    }
  });